module.exports = __webpack_public_path__ + "media/26.842ac0ca.wav";